import { render, staticRenderFns } from "./PlatformRecommendation.vue?vue&type=template&id=44357618"
import script from "./PlatformRecommendation.vue?vue&type=script&lang=js"
export * from "./PlatformRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports